import { createStore, applyMiddleware, compose } from "redux";
import thunk from "redux-thunk";
import logger from "redux-logger";

import credentialReducer from "./reducers";

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

const store = createStore(
  credentialReducer,
  composeEnhancers(applyMiddleware(logger, thunk))
);

export default store;



// WEBPACK FOOTER //
// src/store/configureStore.js